"use client";
import * as React from "react";

export function BackgroundElements() {
  return (
    <>
 <svg
    viewBox="0 0 1920 970"
    xmlns="http://www.w3.org/2000/svg"
    className="absolute left-[-650px] top-[-1100px] w-[2600px] h-[2290px] rotate-[-18.728deg] -z-10"
    fill="none"
  >
    <g filter="url(#filter0_d)">
      <path
        d="M2011.2 -290.592C2140.28 90.1576 1764.35 621.132 1149.26 829.671C534.159 1038.21 -87.1794 845.345 -216.267 464.596C-345.354 83.8463 48.6348 -393.867 663.732 -602.406C1278.83 -810.945 1882.11 -671.341 2011.2 -290.592Z"
        fill="#3A3350"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="-290.759"
        y="-745.187"
        width="2377.29"
        height="1714.31"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="25" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.110577 0 0 0 0 0.110577 0 0 0 0 0.110577 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </svg>

      <div>
        <div
          dangerouslySetInnerHTML={{
            __html:
              "<svg id=\"12:724\" width=\"1855\" height=\"2385\" viewBox=\"0 0 1855 2385\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"blur-circle-1\" style=\"width: 499px; height: 499px; position: absolute; left: 1349px; top: 1186px; z-index: 1\"> <g filter=\"url(#filter0_f_12_724)\"> <circle cx=\"1249.5\" cy=\"1135.5\" r=\"249.5\" fill=\"#B28DFF\"></circle> </g> <defs> <filter id=\"filter0_f_12_724\" x=\"0\" y=\"-114\" width=\"2499\" height=\"2499\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\"> <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"></feFlood> <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"BackgroundImageFix\" result=\"shape\"></feBlend> <feGaussianBlur stdDeviation=\"500\" result=\"effect1_foregroundBlur_12_724\"></feGaussianBlur> </filter> </defs> </svg>",
          }}
        />
      </div>

      <div>
        <div
          dangerouslySetInnerHTML={{
            __html:
              "<svg id=\"12:892\" width=\"1172\" height=\"2170\" viewBox=\"0 0 1172 2170\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"blur-circle-2\" style=\"width: 570px; height: 570px; border-radius: 570px; background: #FF82BD; filter: blur(400px); position: absolute; left: 0; top: 0; z-index: 1\"> <g filter=\"url(#filter0_f_12_892)\"> <circle cx=\"285\" cy=\"285\" r=\"285\" transform=\"matrix(1 0 0 -1 -198 1370)\" fill=\"#FF82BD\"></circle> </g> <defs> <filter id=\"filter0_f_12_892\" x=\"-998\" y=\"0\" width=\"2170\" height=\"2170\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\"> <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"></feFlood> <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"BackgroundImageFix\" result=\"shape\"></feBlend> <feGaussianBlur stdDeviation=\"400\" result=\"effect1_foregroundBlur_12_892\"></feGaussianBlur> </filter> </defs> </svg>",
          }}
        />
      </div>

      <div>
        <div
          dangerouslySetInnerHTML={{
            __html:
              "<svg id=\"12:1011\" width=\"1173\" height=\"2179\" viewBox=\"0 0 1173 2179\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"blur-circle-3\" style=\"width: 579px; height: 579px; border-radius: 579px; background: #FF82BD; filter: blur(400px); position: absolute; left: 1260px; top: 109px; z-index: 1\"> <g filter=\"url(#filter0_f_12_1011)\"> <circle cx=\"289.5\" cy=\"289.5\" r=\"289.5\" transform=\"matrix(1 0 0 -1 800 1379)\" fill=\"#FF82BD\"></circle> </g> <defs> <filter id=\"filter0_f_12_1011\" x=\"0\" y=\"0\" width=\"2179\" height=\"2179\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\"> <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"></feFlood> <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"BackgroundImageFix\" result=\"shape\"></feBlend> <feGaussianBlur stdDeviation=\"400\" result=\"effect1_foregroundBlur_12_1011\"></feGaussianBlur> </filter> </defs> </svg>",
          }}
        />
      </div>

      <div>
        <div
          dangerouslySetInnerHTML={{
            __html:
              "<svg id=\"12:1012\" width=\"1127\" height=\"2087\" viewBox=\"0 0 1127 2087\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"blur-circle-4\" style=\"width: 487px; height: 487px; border-radius: 487px; background: #FF82BD; filter: blur(400px); position: absolute; left: 1913px; top: 1670px; z-index: 1\"> <g filter=\"url(#filter0_f_12_1012)\"> <circle cx=\"243.5\" cy=\"243.5\" r=\"243.5\" transform=\"matrix(1 0 0 -1 800 1287)\" fill=\"#FF82BD\"></circle> </g> <defs> <filter id=\"filter0_f_12_1012\" x=\"0\" y=\"0\" width=\"2087\" height=\"2087\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\"> <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"></feFlood> <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"BackgroundImageFix\" result=\"shape\"></feBlend> <feGaussianBlur stdDeviation=\"400\" result=\"effect1_foregroundBlur_12_1012\"></feGaussianBlur> </filter> </defs> </svg>",
          }}
        />
      </div>
    </>
  );
}
